import { render } from "./UnsafeWebsites.vue?vue&type=template&id=274cf9e3&scoped=true"
import script from "./UnsafeWebsites.vue?vue&type=script&lang=js"
export * from "./UnsafeWebsites.vue?vue&type=script&lang=js"

import "./UnsafeWebsites.vue?vue&type=style&index=0&id=274cf9e3&scoped=true&lang=css"

import exportComponent from "/go/src/bitbucket.org/VertexSecurity/xsurflog_vuejs/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-274cf9e3"]])

export default __exports__